import React from 'react'
import type { ComposeComponentImageAndAdjacentTextListFragment } from '../../../.graphql/generated-types'
import { notEmpty } from '@marketing-sites/utils'
import { ComposeComponentImageAndAdjacentText } from '../ComposeComponentImageAndAdjacentText'

export interface ImageAndAdjacentTextListProps {
  data: ComposeComponentImageAndAdjacentTextListFragment
}

export function ImageAndAdjacentTextList({
  data,
}: ImageAndAdjacentTextListProps) {
  const items = (data.imageAndTextItemsCollection?.items ?? []).filter(notEmpty)
  if (items.length > 0) {
    return (
      <ul>
        {items.map((imageAndAdjacentText) => (
          <li key={imageAndAdjacentText.sys.id}>
            <ComposeComponentImageAndAdjacentText data={imageAndAdjacentText} />
          </li>
        ))}
      </ul>
    )
  }
  return null
}
